import pkg from "../package.json";

export const BASE_APP_NAME = "payment-container-front";
export const APP_VERSION = pkg.version;

export const API_URL =
    process.env.REACT_APP_API_URL || "http://localhost:3456/";
export const BASE_PATH = process.env.REACT_APP_BASE_PATH || "/";
export const NODE_ENV = process.env.NODE_ENV;

export const PRIVACY_POLICY_URL =
    process.env.REACT_APP_PRIVACY_POLICY_URL ||
    "https://tc.teamsystem.com/InformativaPrivacyTSDigital.pdf";
export const COOKIE_POLICY_URL =
    process.env.REACT_APP_COOKIE_POLICY_URL ||
    "https://app.teamsystemdigital.com/cookie-policy/index.html";

// Tests
export const FAKE_ENV_FOR_TESTING =
    process.env.REACT_APP_FAKE_ENV_FOR_TESTING === "true";

// GainSight
export const GAINSIGHT_CUSTOM_EVENT_PREFIX = "payment-container-front";
export const GAINSIGHT_TAG_KEY = process.env.REACT_APP_GAINSIGHT_TAG_KEY;
